<template>
  <div>
    <page-table :changeOrderCode="changeOrderCode" :disabled="disabled" />
  </div>
</template>
<script>
import PageTable from "./components/table"
export default {
  props: {
    changeOrderCode: String,
    disabled: { type: Boolean, default: false },
  },
  components: { PageTable },
}
</script>
